import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {VideoEntityBlock} from '../../../models/videoDocument.model';

@Component({
  selector: 'app-video-image-entity-item',
  templateUrl: './video-image-entity-item.component.html',
  styleUrls: ['./video-image-entity-item.component.scss']
})
export class VideoImageEntityItemComponent implements OnInit {

  @Input() data: VideoEntityBlock;
  @Output() remove: EventEmitter<VideoEntityBlock> = new EventEmitter<VideoEntityBlock>();
  @Output() jumpTo: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  onJumpTo() {
    this.jumpTo.emit();
  }

  removeItem() {
    this.remove.emit(this.data);
  }
}
